import $ from "jquery";
import "slick-carousel";

const slideCard = () => {
  const init = () => {
    slider();
  };

  const slider = () => {
    const el = {
      slide: ".js-FaqQuestion__Fields__Wrapper",
    };

    if ($(el.slide).length === 0) return;

    $(el.slide).slick({
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      variableWidth: true,
    });
  };

  init();
};

try {
  slideCard();
} catch (error) {
  console.error("Slide Card:", error);
}
